const appConstants =  {
  
  spWSPublicBaseUrl: process.env.REACT_APP_API_BASE_URL_PUBLIC,
  spWSProtectedBaseUrl: process.env.REACT_APP_API_BASE_URL,

  spSuperAdminUrl: process.env.REACT_APP_API_SUPER_ADMIN_URL,


  spWSPaths: {
    users: {
      login: 'users/login',
      list: 'users/list',
      team: 'users/team',
      listByFilterType: 'users/listByFilterType',
      create: 'users/create',
      createAdminUser: 'users/addDashboardUser',
      update: 'users/update',
      details: 'users/userDetails/:emailID',
      delete: 'users/delete/:userID',
      activityList: 'user/activity/list',
      userRoleList: 'userRole/list',
      userRoleAssign: 'userRole/assign',
      userRoleUnassign: 'userRole/delete/:userRoleID',
      logout: 'users/logout',
      userActivityTimeline: 'userActivityTimeline/:userID',
      userConfigList:'users/userConfig/list',
      // storeOwnerDetails: 'users/storeOwnerDetails',
      // forgotPassword: 'users/forgotPassword/:emailID',
      resetPassword: 'users/resetPassword',
      generateSecurePhrase: 'users/generateSecurePhrase',
      saveToken: 'users/fcmtoken/save',
      userConfigList: 'users/config/list',
      saveUserConfig: 'users/config/save',
      notificationTypeList: 'users/config/notificationType/list',
    },
    userAddress: {
      list: 'users/address/list/:userID',
      save: 'users/address/save',
      details: 'address/details/:userAddressID',
      pincodeDetails: 'pincode/details/:pincodeID'
    },
    
    

    // ------------------- ecomp -start
    company: {
      list: 'entity/list',
      details: 'entity/details/:entityID', //'address/details/:userAddressID',
      save: 'entity/save',  
      recommendedAttributes: 'entity/recommendedAttributes/:countryID',
      dependencies: 'entity/dependencies',
      disable: 'entity/disable',
      compliance: 'entity/compliance/list'
    },
    entityDocument: {
      list: 'entity/entityDocument/list',
      detail: 'entity/entityDocument/details/:entityDocumentID',
      save: 'entity/entityDocument/save',
      saveProperties: 'entity/entityDocument/saveProperties',
      delete: 'entity/entityDocument/delete/:entityDocumentID',
      storageUsed: 'entity/entityDocument/storage/details',
      upload:'entity/file/upload' 
    },
    entityCompliance: {
      list: 'entity/entityCompliance/list',
      all: 'entity/entityCompliance/all',
      distinct: 'entity/entityCompliance/distinct',
      bulkAdd: 'entity/entityCompliance/bulkAdd',
      assignComplianceToEntities: 'entity/entityCompliance/assignComplianceToEntities',
      details: 'entity/entityCompliance/details/:entityComplianceID',
      updateStatus: 'entity/entityCompliance/updateStatus',
      bulkUpdatePolicyCompliance: 'entity/entityCompliance/bulkUpdate'
    },
    entityPolicy: {
      list: 'entity/entityPolicy/list',
      save: 'entity/entityPolicy/save',
      details: 'entity/entityPolicy/details/:entityPolicyID',
      bulkAdd: 'entity/entityPolicy/bulkAdd',
      placeholders: 'entity/entityPolicy/placeholders',
      policyActionSave : 'entity/entityPolicy/policyActionSave',
      actorList: 'entity/entityPolicy/actorList',
      history: 'entity/entityPolicy/history/:policyID',
      download : 'entity/entityPolicy/download',
      complianceList :'entity/entityPolicy/entityCompliance/list/:entityPolicyID',
      deleteCompliance: 'entity/entityPolicy/entityCompliance/:entityComplianceID',
      gapAnalysis:'entity/entityPolicy/policyGapAnalysis',
      document: {
        get: 'entity/entityPolicy/document/:entityPolicyID',
        update:'entity/entityPolicy/policyDocument/update'

      }
    },
    policy: {
      category : {
        save: 'policy/category/save',
        list: 'policy/category/list'
      },
      save: 'policy/save',
      details: 'policy/details/:policyID',
      list: 'policy/list',
      history: 'policy/history/:policyID',
      policyActionSave: 'policy/policyAction/save',
      published: 'policy/published/list',
      placeholderList: 'policy/placeholderList',
      document :{
        save: 'policy/document/save',
        get: 'policy/document/:policyID'

      }
    },
    entityActor: {
      list: 'entity/entityActor/list',
      details: 'entity/entityActor/details/:entityActorID',
      save: 'entity/entityActor/save',
      actList: 'entity/entityActwiseActor/findByActor/:entityActorID',
      actSave: 'entity/entityActwiseActor/save',
      actDelete: 'entity/entityActwiseActor/delete/:entityActwiseActorID',
      actWiseList: 'entity/entityActwiseActor/list',
      dependencies: 'entity/entityActor/dependencies',
      swap: 'entity/entityActor/swap'
    },
    entityWFStep: {
      list: 'company/complianceTask/list',
      details: 'entity/entityWorkflowStep/details/:entityWFStepID',
      save: 'entity/entityWorkflowStep/save',
      delete: 'entity/entityWorkflowStep/delete/:entityWFStepID'   
    },
    common: {
      complianceCodeList: 'common/compliance/code/list/:codeGroupID',
      codeList: 'common/codes/list',
      activityList: 'common/activity/list',
      countryList: 'common/country/list',
      eventList: 'common/event/list',
      complianceList: 'common/compliance/list' //export
    },
    compliance: {
      list: 'compliance/list',
      category: 'compliance/category',
      copy: 'compliance/copy'
    },
    repo: {
      save: 'compliance/save',
      token: 'public/token',
      actSave: 'compliance/act/save',
      import: 'compliance/import'
    },
    task: {
      list: 'task/upcoming',
      all: 'task/all',
      details: 'task/taskDetails/:taskNumber',
      upload:'task/file/upload',
      create: 'task/create',
    },
    taskAction: {
      save: 'task/taskAction/save'
    },
    taskData: {
      save: 'task/taskData/save',
      download: 'task/taskData/download/:taskDataID',
      saveFiles: 'task/taskData/saveFiles',
      deleteFile: 'task/taskData/delete/:taskDataID'
    },
    alertBoard: {
      total: 'dashboard/alert/tasks/count',
      overdue: {
        count: 'dashboard/alert/overdue/count',
        entity: {
          chart: 'dashboard/alert/overdue/entity/graph',
          list: 'dashboard/alert/overdue/entity/list'
        },

        actor: {
          chart: 'dashboard/alert/overdue/actor/graph',
          list: 'dashboard/alert/overdue/actor/list'
        },
      },
      nonCompliance: {
        count: 'dashboard/alert/non-compliance/count',
        entity: {
          chart: 'dashboard/alert/non-compliance/entity/graph',
          list: 'dashboard/alert/non-compliance/entity/list'
        },
      },
      partiallyComplied: {
        reason: {
          chart: 'dashboard/alert/partially-complied/reason/graph',
          list: 'dashboard/alert/partially-complied/reason/list'
        }
      },
      cancelled: 'dashboard/alert/cancelled/count',
      
    },
    monetaryRiskBoard:{
      dashboard: 'monetaryRiskBoard/dashboard'
    },
    cSuite: {
      total: {count: 'dashboard/csuite/compliance/count'},
      compliant: {count: 'dashboard/csuite/compliantTask/count'},
      nonCompliant: {count: 'dashboard/csuite/nonCompliantTask/count'},
      penalCompliance: {count: 'dashboard/csuite/penalCompliance/count'},
      monetaryCompliance: {count: 'dashboard/csuite/monetaryCompliance/count'},
      legalCompliance: {count: 'dashboard/csuite/legalCompliance/count'},
      totalPenaltyAmount: {total: 'dashboard/csuite/penaltyAmount/total'},
      PenaltyRisk:{allTask:'dashboard/csuite/penaltyRisk/allTask'},
      ActWiseCount:{count: 'dashboard/risk/actWise/count'},
      riskMatrix: {
        total: 'dashboard/csuite/riskMatrix/total',
        allTasks: 'dashboard/csuite/riskMatrix/allTask'
      }
    },
    reports: {
      taskTracker: 'reports/task/tracker',
      misFormatExport: 'reports/task/trackerExport',
      ccoExceptionDeviationStatusReport: 'reports/cco/exceptionsAndDeviations',
      ccoRegulatoryStatusReport: 'reports/cco/regulatoryStatus',
      misReport:'reports/mis/gridData',
      ccoExcelExport: 'reports/cco/excelExport',
      taskTrackerExport: 'reports/task/excelExport',
      misExcelExport: 'reports/mis/excelExport'
    },
    circular :{
      list : 'reports/circular/list',
      regulator:'reports/circular/source/list',
      circularNumberList: 'reports/circular/circularNumber/list',
      update: 'reports/circular/update'
    },
    homeDashboard: {
      loggedInUser: {
        wipTask: { count: 'dashboard/loggedInUser/wipTask/count'},
        completedTask: { count: 'dashboard/loggedInUser/completedTask/count'},
        dueTodayTask: { count: 'dashboard/loggedInUser/tasksDueToday/count'},
        nearingDueDateTask: {count: 'dashboard/loggedInUser/tasksNearingDueDate/count'},
        overDueTask: {count: 'dashboard/loggedInUser/overdue/count'},
        notCompliedTask: {count: 'dashboard/loggedInUser/nonCompliance/count'},
        averageTime: 'dashboard/loggedInUser/averageResponseTime',
      },
      taskAction: {
        graph:'dashboard/taskAction/graph'
      },
      newsFeed: {
        list: 'dashboard/newsFeed/list'
      }
      
  },
    auditor: {
      autoComplete: 'auditor/autocomplete',
      queryResult: 'auditor/test',
      evidenceLog: 'auditor/evidencelog',
      evidenceLogExport: 'auditor/evidencelog/excelExport'
    },
    notification: {
      list: 'dashboard/notification/list',
      updateStatus: 'dashboard/notification/updateStatus'
    },
    entityEvent: {
      list: 'entity/entityEvent/list',
      expectedTaskList: 'task/entityEvent/expectedTaskList',
      eventTaskList: 'task/entityEvent/taskList/:companyEventID',
      save: 'entity/entityEvent/save',
      excelExport: 'entity/entityEvent/excelExport',
    },
    demo: {
      circular:{
        demoNotification: 'demo/circular/notification'
      },
      securityNewsFeed: 'demo/news/notification'

    },
    // ------------------- ecomp - end
    
    
    
    
    
    products: {
      list: 'product/list',
      all: 'product/all',
      save: 'product/save',
      bulkUpload: 'product/bulkUpload',
      bulkUpload_AS: 'product/bulkUploadAS',
      details: 'product/details/:productID',
      delete: 'product/delete/:productID'
    },
    
    roles: {
      list: 'roles/list',
      create: 'roles/create',
      update: 'roles/update',
      delete: 'roles/delete/:roleID',
      details: 'role/details/:roleID'
    },
    roleActivityAccess: {
      details: 'roleActivity/details',
      save: 'roleActivity/save',
    },
    
    registration: {
      prospectDetails: 'onboarding/customer/prospect/details/:customerCode',
      prospectSave: 'onboarding/customer/prospect/save',
      oauth: 'onboarding/customer/prospect/oauth',
      isEmailAvailable: 'onboarding/customer/prospect/checkIfAvailable/:contactEmailID',
      generateVerificationToken: 'onboarding/customer/prospect/generateVerificationToken',
      reGenerateVerificationToken: 'onboarding/customer/prospect/reGenerateVerificationToken',
      verifyToken: 'onboarding/customer/prospect/verifyToken',
      countryList: 'onboarding/common/country/list',
      stripeGuestCheckoutActivate: 'onboarding/customer/stripeGuestCheckout/activate'
    },
    
  },
  
  activityAccess: {
    create: 8,
    read: 4,
    update: 2,
    delete: 1,
    all: 15,
    none: 0
  },

  activity: {
    entityManagement: 1,
    entityList:2,
    complianceList: 3,
    eventList: 4,
    myTasks: 7,
    companyList: 6,
    taskBuilder: 5,
    companyComplianceList: 7,
    cSuiteSummary: 11,
    performanceTracker: 12,
    taskTracker: 12,
    allTeamTasks: 13,
    auditorResources: 14,
    repoList: 16,
    userList: 19,
    roleList: 20,
    mySettings: 21,
    allEntities: 22,
    allDeptTasks: 23,
    policyRepo: 24,
    entityPolicy: 25,
    circular: 26,
    myProfile:27,
    notificationList: 28

    // -------------demo only
    ,ropa: 212,
    securities:231,
    sources:232
  },

  codeGroup: {
    userStatus: 100,
    companyType: 102,
    industryType: 103,
    actorType: 104,
    entityComplianceStatus: 106,
    approvalType: 107,
    dataType: 108,
    taskAction: 109,
    event: 110,
    oneTime:111,
    recurring: 112,
    regulatorType: 114,
    riskType: 115,
    reasonDoneWithException: 116,
    reasonCancelled: 117,
    BroadcastChannel:118,
    notificationStatus: 119,
    taskStatus: 120,
    entityActorStatus: 124,
    companyStatus: 126,
    policyActor: 127,
    policyStatus: 128,
    entityPolicyStatus: 129,
    entityPolicyActorType: 130,
    likelihoodType: 131,
    impactType: 132,
    notificationCategory: 135,
    notificationObjectType: 136
  },
  notificationType: {
    taskAction: 13501,
    workflowUpdated: 13502,
    summaryEmail: 13503,
    newCircular: 13504,
    userCreated: 13505,
  },

  notificationObjectType: {
    task: 13601,
    circular: 13602
  },
  
  scheduleType: {
    oneTime: 11101,
    eventBased: 11002
  },

  recurrenceType:{
    weekly: 11201,
    monthly: 11202,
    quarterly: 11203,
    halfYearly: 11204,
    yearly: 11205,
  },

  complianceStatus: {
    all: 113,
    draft: 11301,
    published: 11302
  },

  regulator: {
    rbi:11401
  },

  notificationStatus: {
    read: 11901,
    unRead: 11902
  },

  configKey: {
    subscribedToRepo: 12301,
  },
  entityActorStatus: {
    active: 12401,
    inactive: 12402
  },


  companyType: {
    all: 10201
  },
  
  industryType: {
    all: 10301
  },

  entityComplianceStatus: {
    draft: 10601,
    active: 10602,
    inactive: 10603
  },
  actorType: {
    maker: 10401,
    checker: 10402,
    approver: 10403,
    owner: 10404
  },
  sourceType: {
    repo: 10501,
    adHoc: 10502,
    documentRenewal: 10503
  },
  approvalType: {
    notRequired: 10701,
    mandatory: 10702
  },
  dataType: {
    string: 10801,
    number: 10802,
    date: 10803,
    file: 10804,
    entityDocument: 10805
  },
  taskAction: {
    created: 10901,
    done: 10902,
    approved: 10903,
    rejected: 10904,
    canceled: 10905,
    doneWithException: 10906,
    reviewed: 10907,
    complied: 10908,
    compliedWithException: 10909,
    rescheduled: 10910,
    reassigned: 10911
  },
  dateType:{
    dueDate:12501,
    complianceDate:12502,
    forPeriodDate:12503,
    actualCompletionDate:12504
  },
  months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  sliderTimeline: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,30,35,40,45,50,55,60,65,70,75,80,85,90,95,100,105,110,115,120,135,150,165,180,195,210,225,240,255,270,285,300,315,330,345,360],

  likelihoodCodeType: {
    default: 13103
  },
  impactCodeType: {
    default: 13203
  },













  userStatus: {
    active: 10001,
    pending: 10002,
    deleted: 10003
  },


  productStatus: {
    active: 10501,
    inactive: 10502,
    upcoming: 10503
  },




  customerStatus: {
    active: 13001,
    pending: 13002,
    cancelledSubscription: 13003
  },


  entityStatus: {
    active: 12601,
    inactive: 12602,
  },


  productType: {
    physical: 15501,
    digital: 15502,
    affiliate: 15503
  },

  policyActorType: {
    draft: 12701,
    approve: 12702,
    publish: 12703
  },

  policyActionType: {
    draft: 12801,
    sentForApproval: 12802,
    approved: 12803,
    published: 12804,
    canceled: 12805,
    changesRecommended: 12806
  },
  entityPolicyAction: {
    added: 12901,
    adopted: 12902,
    mappedControls: 12903,
    reviewed: 12904
  },

  entityPolicyActorType: {
    adopt: 13001,
    review: 13002
  },
  
  businessCategory: {
    yourStore: 12902
  },


  
  tagSuggestions: [
    { id: 1, name: 'Featured' }, 
    { id: 2, name: 'Popular' }, 
    { id: 3, name: 'Best seller'}, 
    { id: 4, name: 'Trending'}
  ],

  userTagSuggestions: [
    { id: 1, name: 'High spenders' }, 
    { id: 2, name: 'Cart abandoners' }, 
    { id: 3, name: 'Coupon lovers'}, 
    { id: 4, name: 'One timers'},
    { id: 5, name: 'Newsletter readers'},
    { id: 6, name: 'Indecisive shoppers'},
    { id: 7, name: 'Loyal customers'}
  ],

  

  regexExpressions: {
    ratings: /^[1-5](\.\d{1,2})?$/,
    numberOnly: /\d+$/,
    money: /^\d+(\.\d{1,2})?$/,
    alphaNumericWithSpace: /^[\w\-\s\(\)]+$/,
    alphaNumericNoSpace: /^[\w\-]+$/,
    noSpecialCharacters: /^[^<>%$=!]*$/, // for descriptions
    documentName: /^[a-zA-Z0-9-()\s\.]+$/,
    //pan:/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/,
    pan:/^[a-zA-Z0-9]{10}$/,
    cin:/^([L|U]{1})([0-9]{5})([A-Za-z]{2})([0-9]{4})([A-Za-z]{3})([0-9]{6})$/,
    emailID: /^[^\s@]+@[^\s@]+\.[^\s@]{2,5}$/,
    phone: /^[+]?[0-9\s-]*$/,
    password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d!@#$%^&*()_+]{8,}$/,
    name: /^[a-zA-Z]+$/,
    hexRGB: /^#(?:[0-9a-fA-F]{3}){1,2}$/,
    doubleSlash: /\/\//g,
    iframeUrl: /(src)=["']?((?:.(?!["']?\s+(?:\S+)=|\s*\/?[>"']))+.)["']?/, // /(?<=src=").*?(?=[\*"])/,// check work around for safari. - https://stackoverflow.com/questions/65918620/regex-is-working-on-chrome-but-not-in-safari
    domainName: /^(?!-)[A-Za-z0-9-]+([\-\.]{1}[a-z0-9]+)*\.[A-Za-z]{2,6}$/,
    indianPincode: /^\d{6}$/, ///  /^\d(6)$/,
    url:/[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/,
    brandName: /^[a-zA-Z\s0-9-_]+$/,
    riskExpression: /^$|^[\s0-9()+\-*/.<>=!?:]*(_daysDelayed_)[\s0-9()+\-*/.<>=!?:]*$/
  },
  
  country: {
    india: 101,
    usa: 233,       
  },
  

  elasticIndex : {
    productIndex: 'products_index',
    actIndex: 'act_index',
    complianceIndex: 'compliance_index',
  },
  
  httpHeaderKey: {
    responseAuthToken: 'x-auth-token',
    requestAuthToken: 'Authorization',
    requestAuthTokenPrefix: 'Bearer ',
    responseCustomerID: 'customerID',
    requestCustomerID: 'customerID',
    responseResetToken: 'x-reset-token'
  },

  cookieKey: {
    authToken: 'wjdcmuwihe',
    repoToken: 'sdqpuqldnn',
    resetToken: 'jsndpokpo',
  },
  localStorageKey: {
    currentUser: 'n3jnriesnfnv',
    customerID: 'knsanlnfv',
    activityList: 'bhiqjpqugzol',
    prospectInfo: 'qosptofdu1a',
    circularInfo: 'cvgghjaaymzi',
    webPush: '12ntkcmwbps',
    frameworkRecommendation: 'frp89cwpzlgq',
    entityPolicyDocument: 'eps87wpvamh0d',
    securityDetail:'scdtjpqudu1a', 
    riskScore: 'pofjirgjnrs',     

    
    listPageSearch: 'lspswenkpp',// datatype of data stored is object
    listPageSearchKey: {
      repoComplianceList: 'rco',
      selectableCompliance: 'scp',
      entityCompliance: 'ecp',
      leftMenuCompliance: 'lcp',
      entity:'ent',
      event: 'evt',
      pendingTasks: 'pen',
      allTasks: 'all',
      cSuiteSummary:'csu',
      monetaryRiskBoard:'mru',
      policy: 'plc',
      advancedReports: 'rpt',
      misReport: 'mis',
      riskMatrix: 'rkm',
      entityPolicyDocument: 'epc',      
      // product: 'prd',
      // category: 'cat',
      // customer: 'cus',
      // order: 'ord',
      // cart: 'car'
      riskFramework: 'rfw',
      riskAssessment: 'ras'
    }
  },

  messages: {
    httpDefaultError: 'common_unhandled_exception',
    userLoginError: 'user_login_error',
    userAuthTokenFailure: 'user_authentication_failure',
    noDataFound: ['user_list_no_matching_record_found', 'role_not_found',
      'product_list_no_matching_record_found', 'order_list_no_matching_record_found',
      'userProduct_list_no_matching_record_found', 'product_category_list_no_matching_record_found', 'discount_list_no_matching_record_found',
      'common_not_found']
  },

  toastMessage: {
    errorTimeout: 5000
  },
  entityPageCount: 300,
  taskPageCount: 1500,

  FileUploadRestrictions: {
    maxFileSize: 10 * 1024 * 1024, //10 MB
    minFileSize: 1 * 1024,  //1 KB
    maxNumberOfFiles: 25,
    maxTotalFileSize: 10 * 1024 * 1024 ,//10 MB
    allowedFileTypes:[
      ".jpg", ".jpeg", ".png", 
      ".JPG", ".JPEG", ".PNG",
      ".pdf", ".doc", ".docx", ".ppt", ".pptx",
      ".PDF", ".DOC", ".DOCX", ".PPT", ".PPTX",
      ".xls", ".xlsx",
      ".XLS", ".XLSX",
      ".zip", ".ZIP"],
  },

  advancedReportsRestrictions: {
    maxComplianceSizeForMIS: 25
  },
  notification: {
    browserPermission: {
      granted :"granted"
    },
    PostMessage: {
      navigate: "NAVIGATE",
      store: "STORE_NOTIFICATION"
    }
  }
  ,demo: {
    upsiQs: 'UPSI Questionnaire',
    qs: 'Questionnaire',
    dataMapping: 'data mapping',
    role: {dpo: 'dpo'}
  }
}

export default appConstants
